<div class="modal-header">
  <h3 class="statements-modal-title">{{'team_statements_modal_title'|translate}}</h3>
  <img src="assets/svg/close-button.svg" alt="X" aria-label="Close" (click)="close()"
       style="margin: 0 0 3rem 0; cursor: pointer">
</div>
<div class="statements-modal-body">
  <div class="loading-bubbles" *ngIf="config.statements.length===0">
    <span class="spinner-grow text-primary" role="status"></span>
    <span class="spinner-grow text-primary" role="status"></span>
    <span class="spinner-grow text-primary" role="status"></span>
  </div>
  <div class="statement-cell" *ngFor="let statement of config.statements">
    <div class="statement-cell-icon"><i style="color: white" class="bi bi-chat-fill statement-icon"></i></div>
    <span style="font-size: 1.6rem">{{statement.question.title}}</span>
  </div>
</div>
